import { getVSIFileIcon } from 'file-extension-icon-js';

import IcExcel from '../assets/icons/iconExcelNovo.svg'
import Psd from '../assets/icons/psd.svg'
import Ic from "../assets/icons/iconsIcs.png";
import Id from "../assets/icons/iconId.png";
import Pm from "../assets/icons/pm.png";
import Ps from "../assets/icons/iconPs.png";
import Mp from "../assets/icons_/mp4.svg";
import Pdf from "../assets/icons_/pdf.svg";
import Ppo from "../assets/icons_/ppoint.svg";
import Txt from "../assets/icons_/txt.svg";
import Word from "../assets/icons_/word.svg";
import Xd from "../assets/icons_/xd.svg";
import Ai from "../assets/icons/ai.png";
import Pr from "../assets/icons/pr.png";



const _difference = async (a1, a2) => {
  let a2Set = new Set(a2);
  return a1.filter(function (x) { return !a2Set.has(x); });
}

// retorna elementos diferentes entre dois arrays
export const arrayDiference = async (arrayA, arrayB) => {
  return _difference(arrayA, arrayB).concat(_difference(arrayB, arrayA))
}

// retorna elementos iguais entre dois arrays
export const arrayInterseccao = async (arrayA, arrayB) => {
  return arrayA.filter(x => arrayB.includes(x))
}

// converte data
export const convertDateIsoToDate = async (date, format = false) => {
  let newDate = ''
  if (format === false) {
    newDate = new Date(
      date.substring(0, 4),
      date.substring(5, 7) - 1,
      date.substring(8, 10),
      date.substring(11, 13),
      date.substring(14, 16),
      date.substring(17, 19)
    )
  } else {
    newDate = `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`
  }
  return newDate
}

export const retornarStatusContrato = (valor) => {
  switch (valor) {
    case 2:
      return 'Ativo';
    case 3:
      return 'Inativo';
    default:
      return 'Pentende';
  }
}

export const validarCNPJ = (cnpj) => {

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj == '') return false;

  if (cnpj.length != 14)
    return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999")
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;

}

export const calcularTamanhoArquivo = (tamanhoArquivo) => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  let len = tamanhoArquivo;
  let order = 0;

  while (len >= 1024 && order < sizes.length - 1) {
    order++;
    len = len / 1024;
  }

  return `${len.toFixed(2)} ${sizes[order]}`;
}

export const formatarData = (value) => {
  if (value) {
    const data = new Date(value);
    return data.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  }
}

export const validarVisualizar = (extensao = '') => {
  if (extensao != '') {
    switch (String(extensao).toLocaleLowerCase()) {
      case 'mp4':
      case 'mkv':
      case 'mpeg':
      case 'mpg':
      case 'wmv':
        return 'video';
      case 'pptx':
      case 'pptm':
      case 'ppt':
      case 'potx':
      case 'potm':
      case 'pot':
      case 'ppsx':
      case 'ppsm':
      case 'pps':
        return 'power-point';
      case 'pdf':
        return 'pdf';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'bmp':
      case 'gif':
      case 'svg':
        return 'imagem';
      case 'docx':
      case 'doc':
      case 'docm':
      case 'dotx':
      case 'dotm':
        return 'word';
      default:
        return 'nao-suportado';
    }
  }
}

export const validarSePassouDaDataDeValidadeArquivo = (dataVencimentoInicial, dataVencimentoFinal, IsAdmin) => {
  
 if(IsAdmin.toLocaleLowerCase() == "true"){
    return false;
 }

 if (dataVencimentoInicial && dataVencimentoFinal) {
 
    let dataVencimentoInicialDate = new Date(dataVencimentoInicial);
    let dataVencimentoFinalDate = new Date(dataVencimentoFinal);
    let dataAtual = new Date();

    var date1 = Number(dataVencimentoInicialDate);
    var date2 = Number(dataVencimentoFinalDate);

    if(Number(dataVencimentoInicialDate) <= Number(dataAtual) && 
       Number(dataAtual) <= Number(dataVencimentoFinalDate)){
      return false;
    }else{
      return true;
    }

  }else{
    return false;
  }
}

export const validarSePassouDaDataDeValidade = (data) => {
  if (!data || data.includes('0001')) {
    return false;
  } else {
    let dataVencimento = new Date(data);
    let dataAtual = new Date();
 
    if (Number(dataVencimento) < Number(dataAtual)) {
      return true;
    } else {
      return false;
    }
  }

}

export const validarData = (data) => {
  if(data == "0001-01-01T00:00:00") {
    return false;
  }
  if (data == null || data == undefined) {
    return false;
  }
  let dataVencimento = new Date(data);
  let dataAtual = new Date();

  if (Number(dataVencimento) < Number(dataAtual)) {
    return true;
  } else {
    return false;
  }
}

export const getTipoArquivoImagem = (extensao = '') => {
  let icone;

  switch (String(extensao).toLocaleLowerCase()) {
    case 'mp4':
    case 'mkv':
    case 'mpeg':
    case 'mpg':
    case 'wmv':
      return 'MP4';
    case 'pptx':
    case 'pptm':
    case 'ppt':
    case 'potx':
    case 'potm':
    case 'pot':
    case 'ppsx':
    case 'ppsm':
    case 'pps':
      return 'PowerPoint';
    case 'pdf':
      return 'PDF';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'bmp':
    case 'gif':
    case 'svg':
      return 'IMG';
    case 'csv':
    case 'xlsx':
    case 'xlsm':
    case 'xlsb':
    case 'xltx':
    case 'xltm':
    case 'xls':
    case 'xml':
    case 'xlam':
    case 'xla':
      icone = IcExcel;
      break;
    case 'txt':
    case 'prn':
      return 'TXT'
    case 'docx':
    case 'doc':
    case 'docm':
    case 'dotx':
    case 'dotm':
      return 'Word';
    case 'psd':
    case 'cdr':
    case 'ai':
      return 'PSD';
    default:
      return 'nao-suportado';
  }

  return icone;
}


export const getIconesExtensao = (extensao = '') => {
  let icone;
  switch (String(extensao).toLowerCase()) {
    case 'xd':
      icone = Xd;
      break;
    case 'pdf':
      icone = Pdf;
      break;
    case 'pptx':
      case 'pptm':
      case 'ppt':
      case 'potx':
      case 'potm':
      case 'pot':
      case 'ppsx':
      case 'ppsm':
      case 'pps':
        icone = Ppo;
        break;
    case 'docx':
      case 'doc':
      case 'docm':
      case 'dotx':
      case 'dotm':
        icone = Word;
        break;
    case 'txt':
      case 'prn':
        icone = Txt;
        break;
    case 'mp4':
      case 'mkv':
      case 'mpeg':
      case 'mpg':
      case 'wmv':
        icone = Mp;
        break;
      case 'csv':
      case 'xlsx':
      case 'xlsm':
      case 'xlsb':
      case 'xltx':
      case 'xltm':
      case 'xls':
      case 'xml':
      case 'xlam':
      case 'xla':
        icone = IcExcel;
        break;
    case "icap":
    case "icma":
    case "icml":
      icone = Ic;
      break;
    case "idap":
    case "idml":
    case "indb":
    case "indd":
    case "indl":
    case "indt":
    case "inx":
      icone = Id;
      break;
    case "pmd":
      icone = Pm;
      break;
    case "psb":
      case 'psd':
        case 'cdr':
      
      icone = Ps;
      break;
      case 'ai':
        icone = Ai;
      break;
      case 'prproj':
        icone = Pr;
      break;
      
    default:
      icone = getVSIFileIcon(extensao);
  }
  
  return icone;
}